import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Switch, useHistory } from "react-router-dom";
import "./App.css";
import { loginRequest, msalConfig } from "./authConfig";
import AnalyticsPage from "./function-components/AnalyticsPage";
import Footer from "./function-components/Footer";
import Navbarmenu from "./function-components/Navbarmenu";
import { PageLayout } from "./function-components/PageLayout";
import SearchNav from "./function-components/Searchnav";
import Faq from "./pages/Faq";
import Home from "./pages/Home";
import Sponsor from "./pages/Sponsor";
import { CustomNavigationClient } from "./utils/NavigationClient";
function App({ pca }) {
 // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
 const history = useHistory();
 const navigationClient = new CustomNavigationClient(history);

 pca.setNavigationClient(navigationClient);

 return (
  <MsalProvider instance={pca}>
   <PageLayout>
    <div container justifyContent="center">
     <Pages />
    </div>
   </PageLayout>
  </MsalProvider>
 );
}
function Pages() {
 const msalInstance = new PublicClientApplication(msalConfig);
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [loggedInEnterpriseId, setloggedInEnterpriseId] = useState("");

 useEffect(() => {
  if (activeAccount) {
   fetchAccessToken();
   setloggedInEnterpriseId(activeAccount.idTokenClaims.enterpriseID);
  }
 }, [activeAccount]);
 const allowedUsersForContibution = [
  "aluru.akash",
  "ankur.e.mishra",
  "h.srinivasan",
  "jeevadharani.ramanan",
  "arpita.m.singh",
  "uma.rani.battu",
  "aayushi.bharti",
"reshmi.haridas.m",
  "varsha.a.tyagi",
  "manika.madaan",
  "devika.gajanan.pote",
  "s.saraswathi",
  "niyati.deshmukh",
  "d.prashant.yende",
  "sonal.prakash.lad",
 ];
 const fetchAccessToken = async () => {
  if (!activeAccount)
   throw Error(
    "No active account! Verify a user has been signed in and setActiveAccount has been called.",
   );
  try {
   const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: activeAccount,
   });
   const bearer = `Bearer ${response.accessToken}`;
   localStorage.setItem("token", bearer);
  } catch (error) {
   console.error("Error fetching access token:", error);
   localStorage.clear();
  }
 };
 return (
  <>
   <Router>
    <SearchNav />
    <Navbarmenu />
    <Switch>
     <Route exact path="/">
      <Home />
     </Route>
     <Route exact path="/home">
      <Home />
     </Route>
     <Route exact path="/faq">
      <Faq />
     </Route>
     <Route exact path="/sponsors">
      <Sponsor />
     </Route>
     <Route exact path="/analytics">
      {allowedUsersForContibution.includes(loggedInEnterpriseId) ? (
       <AnalyticsPage />
      ) : (
       <div style={{ height: "100vh", alignContent: "center", textAlign: "center" }}>
        <h5>Need Admin Access to view this page</h5>
       </div>
      )}
     </Route>
    </Switch>
    <Footer />
   </Router>
  </>
 );
}

export default App;
